import { NAVIGATE } from "../actions/navigation";

const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

const gtag = window.gtag;

export default store => next => action => {
  switch( action.type ) {
    case NAVIGATE:
      gtag('config', TRACKING_ID, {
        'page_path': action.url.pathname
      });
    break;
    default:
  }
  return next(action);
}



// WEBPACK FOOTER //
// ./src/middlewares/google-analytics.js